import { render, staticRenderFns } from "./clientTransactionDetails.vue?vue&type=template&id=3f643cb3&scoped=true"
import script from "./clientTransactionDetails.vue?vue&type=script&lang=js"
export * from "./clientTransactionDetails.vue?vue&type=script&lang=js"
import style0 from "./clientTransactionDetails.vue?vue&type=style&index=0&id=3f643cb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f643cb3",
  null
  
)

export default component.exports